import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { VernostServiceService } from "../services/vernost-service.service";

@Component({
  selector: "app-recoverpassword",
  templateUrl: "./recoverpassword.component.html",
  styleUrls: ["./recoverpassword.component.css"]
})
export class RecoverpasswordComponent implements OnInit {
  screen_details: any = {};
  email: any = {};
  sms ="";
  emailPattern;
  constructor(
    private route: ActivatedRoute,
    private service: VernostServiceService
  ) {}
  flag = true;
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.email = params["email"];

      //this.param2 = params['param2'];
    });
  }

  submitdata() {
    var newpassword: any = {};
    var newpasswords = this.screen_details.newpass;
    var cnfmpasswords = this.screen_details.cnfmpass;
    console.log(newpasswords);
    console.log(cnfmpasswords);

    if (this.flag) {
      if (
        newpasswords != undefined &&
        newpasswords != " " &&
        cnfmpasswords != undefined &&
        cnfmpasswords != " "
      ) {
        newpassword = newpasswords.trim();
        var data = {
          newpassword: newpassword,
          email: this.email
        };
        this.service.changepassword(data).subscribe(response => {
         this.sms = response[0].message;
        });
      } else {
        alert("fields can't be empty");
      }
    }
  }

  checkpass() {
    this.flag = true;
    var newpassword: any = {};
    var cnfmpassword: any = {};
    var newpasswords = this.screen_details.newpass;
    var cnfmpasswords = this.screen_details.cnfmpass;
   // console.log(newpasswords);
   // console.log(cnfmpasswords);

    if (
      newpasswords != undefined &&
      newpasswords != " " &&
      cnfmpasswords != undefined &&
      cnfmpasswords != " "
    ) {
      newpassword = newpasswords.trim();
      cnfmpassword = cnfmpasswords.trim();

      for (let i = 0; i < newpassword.length; i++) {
        if (newpassword[i] != cnfmpassword[i]) {
          this.flag = false;
        }
      }
      if (this.flag) {
        //alert("both equal");
      } else {
        alert("Password do not match");
      }
    }
  }
  // if(str1.equals(str2) == true) {
  //   println("Equal");  // They are equal so this line will print
  // }
}
